import React from 'react';

const TickIcon = ({ width = '17', height = '14', color = '#789B73' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 1L5.6875 13L1 7.54545" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export default TickIcon;
